import { Box, Card, Divider, IconButton } from "@mui/material";
import PageTitleSubtitle from "../../../components/PageTitleSubTitle";
import localize from "../../../common/localize";
import { Delete, Edit } from "@mui/icons-material";

export default function ClientBranchItem({ branch, onEdit, onDelete }) {
  return (
    <Card variant="outlined" className="w-full flex justify-between gap-2 p-2">
      <Box className="w-full flex flex-col gap-2">
        <Box className="w-full flex justify-between">
          <PageTitleSubtitle
            useEventTitleStyle
            useFieldTitleStyle
            title={branch?.Name}
            subtitle={`${branch?.State?.Name} - ${branch?.City?.Name}`}
          />

          <Box className="flex items-center">
            <IconButton onClick={onEdit}>
              <Edit sx={{ color: "#10366E", width: "16px", height: "16px" }} />
            </IconButton>

            <IconButton onClick={onDelete}>
              <Delete sx={{ color: "red", width: "16px", height: "16px" }} />
            </IconButton>
          </Box>
        </Box>

        <Divider />
        <Box className="flex w-full">
          <Box className="two_columns_grid">
            <Box className="flex items-center">
              <label className="text-xs">
                <b>{localize.address}: </b>
              </label>
            </Box>

            <Box className="flex items-center" sx={{ overflowX: "hidden" }}>
              <label className="text-xs">
                {branch.Address
                  ? `${branch.Address} ${branch.AddressComplement ?? ""}`
                  : branch.AddressComplement}
              </label>
            </Box>

            <Box className="flex items-center">
              <label className="text-xs">
                <b>{localize.phone_number}: </b>
              </label>
            </Box>

            <Box className="flex items-center" sx={{ overflowX: "hidden" }}>
              <label className="text-xs">{branch?.PhoneNumber}</label>
            </Box>

            <Box className="flex items-center" sx={{ whiteSpace: "nowrap" }}>
              <label className="text-xs">
                <b>{localize.email}: </b>
              </label>
            </Box>
            {branch?.Email ? (
              <Box className="flex items-center" sx={{ overflowX: "hidden" }}>
                <label className="text-xs">{branch?.Email}</label>
              </Box>
            ) : (
              <Box className="flex text-xs">{localize.no_data}</Box>
            )}

            <Box className="flex items-center" sx={{ whiteSpace: "nowrap" }}>
              <label className="text-xs">
                <b>{localize.contact_name}: </b>
              </label>
            </Box>
            {branch?.ContactName ? (
              <Box className="flex items-center" sx={{ overflowX: "hidden" }}>
                <label className="text-xs">{branch?.ContactName}</label>
              </Box>
            ) : (
              <Box className="flex text-xs">{localize.no_data}</Box>
            )}
          </Box>
        </Box>
      </Box>
    </Card>
  );
}
